module.exports = __webpack_public_path__ + "static/media/icon-not-checked.64df18fc.svg";